export const USER_MONEY_STATISTICS_MODES = {
    DAILY: { text: "일간", value: "DAILY" },
    WEEKLY: { text: "주간", value: "WEEKLY" },
    MONTHLY: { text: "월간", value: "MONTHLY" },
};
